import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { toast } from 'react-toastify';
import { FaLock } from 'react-icons/fa';
import PasswordInput from '../components/PasswordInput';

const PASSWORD_POLICY_MESSAGE = 'Password must be at least 8 characters and include uppercase, lowercase, number, and special character.';
const isPasswordCompliant = (value) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])\S{8,}$/.test(String(value || ''));

const ChangePassword = ({ onPasswordChanged, onLogoutForced }) => {
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    confirm_new_password: '',
    reason: 'Mandatory password update'
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.current_password || !formData.new_password || !formData.confirm_new_password) {
      toast.error('All password fields are required');
      return;
    }
    if (formData.new_password !== formData.confirm_new_password) {
      toast.error('New password and confirm password must match');
      return;
    }
    if (!isPasswordCompliant(formData.new_password)) {
      toast.error(PASSWORD_POLICY_MESSAGE);
      return;
    }

    try {
      setLoading(true);
      await authAPI.changePassword(formData);
      toast.success('Password changed successfully. Please login again.');
      onPasswordChanged();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card" style={{ maxWidth: '460px' }}>
        <div className="login-logo">
          <FaLock style={{ color: 'var(--primary-color, #2563eb)' }} />
        </div>
        <h2>Change Password</h2>
        <p className="text-center text-muted mb-3">
          Password update is required before accessing the system.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Current Password</label>
            <PasswordInput
              value={formData.current_password}
              onChange={(e) => handleChange('current_password', e.target.value)}
              autoComplete="current-password"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">New Password</label>
            <PasswordInput
              value={formData.new_password}
              onChange={(e) => handleChange('new_password', e.target.value)}
              autoComplete="new-password"
              required
            />
            <small className="text-muted">{PASSWORD_POLICY_MESSAGE}</small>
          </div>
          <div className="form-group">
            <label className="form-label">Confirm New Password</label>
            <PasswordInput
              value={formData.confirm_new_password}
              onChange={(e) => handleChange('confirm_new_password', e.target.value)}
              autoComplete="new-password"
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Reason</label>
            <input
              type="text"
              className="form-control"
              value={formData.reason}
              onChange={(e) => handleChange('reason', e.target.value)}
              placeholder="Reason for password change"
            />
          </div>
          <button type="submit" className="btn btn-primary w-full" disabled={loading}>
            {loading ? 'Saving...' : 'Change Password'}
          </button>
        </form>
        <button type="button" className="btn btn-outline w-full mt-2" onClick={onLogoutForced} disabled={loading}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
